var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOrdershipped(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 39,
    viewBox: "0 0 39 39"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 19.5,
    r: 19.5,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.85
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.783 26.957a2.61 2.61 0 11-5.218-.001 2.61 2.61 0 015.218 0h0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.044 24.511V9.566h-2.609M17.62 27.826h7.989l1.814 1.739M17.783 26.087h8.695v-7.826h-8.695zM23.87 13.913h-6.087v4.348h6.087zM24.739 24.348H23M20.392 16.522h-.87"
  })))));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzOSIgaGVpZ2h0PSIzOSIgdmlld0JveD0iMCAwIDM5IDM5Ij4KICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgPGNpcmNsZSBjeD0iMTkuNSIgY3k9IjE5LjUiIHI9IjE5LjUiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgogICAgPGcgc3Ryb2tlPSIjRkZGIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iLjg1IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMiA5KSI+CiAgICAgIDxwYXRoIGQ9Ik01Ljc4Mjg2OTU3LDE3Ljk1NjUyMTcgQzUuNzgyODY5NTcsMTkuMzk3MzkxMyA0LjYxNDE3MzkxLDIwLjU2NTIxNzQgMy4xNzQxNzM5MSwyMC41NjUyMTc0IEMxLjczMzMwNDM1LDIwLjU2NTIxNzQgMC41NjU0NzgyNjEsMTkuMzk3MzkxMyAwLjU2NTQ3ODI2MSwxNy45NTY1MjE3IEMwLjU2NTQ3ODI2MSwxNi41MTY1MjE3IDEuNzMzMzA0MzUsMTUuMzQ3ODI2MSAzLjE3NDE3MzkxLDE1LjM0NzgyNjEgQzQuNjE0MTczOTEsMTUuMzQ3ODI2MSA1Ljc4Mjg2OTU3LDE2LjUxNjUyMTcgNS43ODI4Njk1NywxNy45NTY1MjE3IEw1Ljc4Mjg2OTU3LDE3Ljk1NjUyMTcgWiIvPgogICAgICA8cG9seWxpbmUgcG9pbnRzPSI0LjA0NCAxNS41MTEgNC4wNDQgLjU2NiAxLjQzNSAuNTY2Ii8+CiAgICAgIDxwb2x5bGluZSBwb2ludHM9IjUuNjIgMTguODI2IDEzLjYwOSAxOC44MjYgMTUuNDIzIDIwLjU2NSIvPgogICAgICA8cG9seWdvbiBwb2ludHM9IjUuNzgzIDE3LjA4NyAxNC40NzggMTcuMDg3IDE0LjQ3OCA5LjI2MSA1Ljc4MyA5LjI2MSIvPgogICAgICA8cG9seWdvbiBwb2ludHM9IjExLjg3IDQuOTEzIDUuNzgzIDQuOTEzIDUuNzgzIDkuMjYxIDExLjg3IDkuMjYxIi8+CiAgICAgIDxsaW5lIHgxPSIxMi43MzkiIHgyPSIxMSIgeTE9IjE1LjM0OCIgeTI9IjE1LjM0OCIvPgogICAgICA8bGluZSB4MT0iOC4zOTIiIHgyPSI3LjUyMiIgeTE9IjcuNTIyIiB5Mj0iNy41MjIiLz4KICAgIDwvZz4KICA8L2c+Cjwvc3ZnPgo=";
export { SvgOrdershipped as ReactComponent };